import React, { FC } from 'react'
import images from 'images'
import styled from 'styled-components'

const Corner = styled.img.attrs({
  src: images.corner,
})`
  position: absolute;
  width: 62px;
  height: 62px;
`

const CornerTL = styled(Corner)`
  top: 0;
  left: 0;
`
const CornerTR = styled(Corner)`
  top: 0;
  right: 0;
  transform: rotate3d(0, 0, 1, 90deg);
`
const CornerBR = styled(Corner)`
  bottom: 0;
  right: 0;
  transform: rotate3d(0, 0, 1, 180deg);
`
const CornerBL = styled(Corner)`
  bottom: 0;
  left: 0;
  transform: rotate3d(0, 0, 1, 270deg);
`

export const Corner2: FC = () => (
  <div>
    <CornerTL />
    <CornerTR />
  </div>
)

export const Corner4: FC = () => (
  <>
    <CornerTL />
    <CornerTR />
    <CornerBR />
    <CornerBL />
  </>
)
